import { registerComponent } from '@gig/magic-common';
import BackgroundComponent from './background.vue.js';

var Background = registerComponent(BackgroundComponent);

export { Background };
